import React from 'react';
import { PageTitle } from '../components';

const PageTitleContainer = () => {
    return ( 
        <PageTitle />
     );
}
 
export { PageTitleContainer };